module.exports = __webpack_public_path__ + "img/incomePng.f98767ea.png";